/* eslint-disable react/no-danger */
import React, { memo, useMemo } from 'react';

// Memoized text formatter for replied text messages
const RepliedTextMessageMC = memo(({ message }) => {
  const messageText = useMemo(() => message.messageText || '', [message.messageText]);
  return (
    <div className="tw-whitespace-pre-line tw-text-xs" dangerouslySetInnerHTML={{ __html: messageText }} />
  );
});

RepliedTextMessageMC.displayName = 'RepliedTextMessageMC';

export default RepliedTextMessageMC;
